const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import ModuleManager from "../../../../framework/core/module_manager";

@ccclass
export default class WebFullScreenView extends ViewBase {

    @property(cc.Node)
    btnfullscreen: cc.Node = null
    @property(cc.Node)
    backgroundin: cc.Node = null
    @property(cc.Node)
    backgroundout: cc.Node = null

}